import { merge } from 'effector';
import { signout } from '@features/common';
import { ControlDomain, ControlGate, fxGetData } from './main';

export const CANCELED_REQUEST_ERROR = 'canceled';

export const $error = ControlDomain.createStore<Error | null>(null);
export const clearError = ControlDomain.createEvent();

/** Передавать все эффекты раздела */
export const errorOccured = merge([fxGetData.fail]);

$error
  .on(errorOccured, (state, { error }) => {
    if (error.message === CANCELED_REQUEST_ERROR) return state;

    try {
      return JSON.parse(error?.message ?? '{}');
    } catch {
      return error;
    }
  })
  .reset([ControlGate.close, signout, clearError]);
